export interface VocabData {
  customRelTypes: Record<string, string[]>;
  customRoleTypes: string[];
  customArchetypes: string[];
}

export const EMPTY_VOCAB: VocabData = {
  customRelTypes: {},
  customRoleTypes: [],
  customArchetypes: [],
};

export const BASE_REL_TYPES: Record<string, string[]> = {
  'char-char':    ['ally', 'enemy', 'rival', 'mentor', 'student', 'family', 'romantic', 'friend', 'colleague', 'complicated'],
  'char-event':   ['participant', 'witness', 'caused', 'victim', 'beneficiary', 'organizer'],
  'char-loc':     ['lives at', 'born at', 'works at', 'visited', 'fled from', 'rules'],
  'loc-event':    ['setting', 'origin point', 'aftermath site'],
  'loc-loc':      ['contains', 'borders', 'adjacent to', 'part of'],
  'event-event':  ['caused', 'preceded', 'prevented', 'overlapped with'],
};

export const BASE_ROLE_TYPES: string[] = [
  'protagonist', 'antagonist', 'supporting', 'mentor', 'minor',
];

export const BASE_ARCHETYPES: string[] = [
  'hero', 'anti-hero', 'villain', 'mentor', 'trickster', 'sidekick',
  'innocent', 'sage', 'outlaw', 'caregiver', 'jester', 'creator', 'explorer', 'ruler',
];

export type PairSegment = 'char' | 'loc' | 'event';

const PAIR_ORDER: PairSegment[] = ['char', 'loc', 'event'];

export function pairKey(a: PairSegment, b: PairSegment): string {
  return [a, b]
    .sort((x, y) => PAIR_ORDER.indexOf(x) - PAIR_ORDER.indexOf(y))
    .join('-');
}

export function entityTypeToPairSegment(entityType: 'character' | 'location' | 'event'): PairSegment {
  if (entityType === 'character') return 'char';
  if (entityType === 'location') return 'loc';
  return 'event';
}
